// extracted by mini-css-extract-plugin
export default {"header":"styles_header__+2-y5","avatar":"styles_avatar__qQJmz"};